var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMemorial(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 100,
    viewBox: "0 0 50 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.3885 88.1323H10.407C9.23763 88.1323 8.31769 87.1334 8.41376 85.968L14.2424 15.2598C14.3279 14.2225 15.1948 13.4241 16.2356 13.4241H33.2823C34.3202 13.4241 35.1856 14.218 35.2749 15.2521L41.3811 85.9602C41.482 87.1284 40.561 88.1323 39.3885 88.1323Z",
    fill: "#DB0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.74 0.813936L33.4794 9.32733C34.0634 9.9697 33.6076 11 32.7395 11H25H17.2606C16.3924 11 15.9366 9.9697 16.5206 9.32732L24.2601 0.813932C24.6569 0.377497 25.3432 0.377499 25.74 0.813936Z",
    fill: "#DB0000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9367 100H1C0.447715 100 -0.00623467 99.5491 0.0480949 98.9995C0.582719 93.5912 5.44186 92.0846 7.94118 92.0233H41.1765C47.0474 92.0233 49.2941 96.1474 49.8584 98.9478C49.9723 99.5129 49.5131 100 48.9367 100Z",
    fill: "#DB0000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemorial);
export default __webpack_public_path__ + "static/media/memorial.a73240ad5413816d7438071bec338335.svg";
export { ForwardRef as ReactComponent };